<template lang="html">
  <div style="height: 100%;">
    <div class="button-wrap toolbar" style="position:absolute; padding:20px; z-index:9999;">
        <button type="button" class="btn btn-default btn-" @click="exportCounter">
          <span class="btn-icon">
            <i class="iconfont icon-export"></i>
          </span>
          导出小区用水信息
        </button>
    </div>
    <DataTablePage ref="historyTable" mainColumn="" longColumn="" title="小区用水统计" label="用水" labelName="" :resource="resource" :noOperationList="noOperationList" :tableFullList="tableFullList" :tableInitList="tableInitList" :filterInitList="filterInitList" :columns="columns" :columnHiddens="columnHiddens" :createFormValues="createFormValues" @changeFormValue="changeFormValue"></DataTablePage>
    <!-- <DataTablePage ref="historyTable" mainColumn="" longColumn="" title="用水历史" label="用水" labelName="" :resource="resource" :noOperationList="noOperationList" :tableFullList="tableFullList" :tableInitList="tableInitList" :filterFullList="filterFullList" :filterInitList="filterInitList" :columns="columns" 
    :columnHiddens="columnHiddens" :createFormValues="createFormValues" @changeFormValue="changeFormValue">
    </DataTablePage> -->
  </div>
<!-- DataTablePage(
    ref="sws"
    mainColumn=""
    longColumn=""
    title="小区用水统计"
    label="用水"
    labelName=""
    :resource="resource"
    :noOperationList="true"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :columns="columns"
    :columnHiddens="columnHiddens"
    :createFormValues="createFormValues"
    @changeFormValue="changeFormValue")-->
</template> 
<script>
import axios from 'axios'
import { fetch } from '@/utils/api'
import DataTablePage from '@/containers/DataTablePage'
import columns from './waterColumns.js'
import { expire } from '@/utils/auth'
export default {
  name: 'sws',
  components: {
    DataTablePage
  },
  data () {
    let nowData = new Date()
    let timeStamp = new Date(nowData.setDate(nowData.getDate() - 1)).getTime()
    return {
      exportDataType: 'ExportDataTypeSubdistrictStatisticsDay',
      intervalId: '',
      noOperationList: true,
      statusType: 'success',
      resource: '/nb/wssd/base',
      tableFullList: ['village', 'hcount', 'lquanty', 'quanty', 'quantyDvalue'],
      tableInitList: ['village', 'hcount', 'lquanty', 'quanty', 'quantyDvalue'],
      filterFullList: ['swsData', 'dateTime', 'monthTime'],
      filterInitList: ['swsData', 'dateTime', 'monthTime'],
      columnHiddens: {
        dateTime: '',
        monthTime: ''
      },
      createFormValues: {
        swsData: '0',
        dateTime: timeStamp,
        monthTime: timeStamp
      },
      filterBy: [],
      // filterFullList: status === 2 ? ['swsData', 'dateTime'] : ['swsData', 'monthTime'],
      // filterInitList: status === 2 ? ['swsData', 'dateTime'] : ['swsData', 'monthTime'],
      columns: {
        ...columns,
        dateTime: {
          label: '选择日期',
          type: 'time',
          dataType: 'YYYY-MM-DD',
          filter: {
            type: 'date',
            hidden: false,
            isNeedUpdateOldValue: true,
            oldValue: timeStamp,
            rules: [{ type: 'required', message: '请选择日期' }]
          },
          // form: {
          //   type: 'date',
          //   hidden: false,
          //   test: false,
          //   isNeedUpdateOldValue: true,
          //   oldValue: timeStamp
          // },
          options: [true]
        },
        monthTime: {
          label: '选择月份',
          type: 'time',
          dataType: 'month',
          dateType: 'month',
          filter: {
            type: 'month',
            hidden: true,
            isNeedUpdateOldValue: true,
            oldValue: timeStamp,
            rules: [{ type: 'required', message: '请选择月份' }]
          },
          // form: {
          //   type: 'month',
          //   hidden: false,
          //   test: false,
          //   isNeedUpdateOldValue: false,
          //   oldValue: timeStamp,
          //   rules: [{ type: 'required', message: '请选择月份' }]
          // },
          options: [true]
        }
      }
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
    this.filterFullList = ['swsData', 'dateTime', 'monthTime']
  },
  methods: {
    changeFormValue (args) {
      let state = args.swsData
      if (state !== null && state !== undefined) {
        this.columnHiddens.dateTime = state === '1'
        this.columnHiddens.monthTime = state === '0'
        this.exportDataType = this.columnHiddens.dateTime ? 'ExportDataTypeSubdistrictStatisticsMonth' : 'ExportDataTypeSubdistrictStatisticsDay'
        this.resource = state === '0' ? '/nb/wssd/base' : '/nb/wssm/base'
      }
    },
    exportCounter () {
      console.log('开始导出计量设备')
      // 获取查询日期
      this.filterBy = this.$refs.historyTable.filterBy
      console.log(this.filterBy)
      var exportTime = ''
      if (this.exportDataType === 'ExportDataTypeSubdistrictStatisticsDay') {
        var newDate = new Date()
        var date = ''
        if (this.filterBy.length > 0) {
          date = new Date(Number(this.filterBy[1].value))
        } else {
          date = new Date(newDate.getTime() - 1000 * 60 * 60 * 24)
        }
        const Y = date.getFullYear()
        const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
        const D = date.getDate() + 1 < 10 ? '0' + date.getDate() : date.getDate()
        exportTime = Y + '-' + M + '-' + D
      } else {
        const date = new Date(Number(this.filterBy[2].value))
        const Y = date.getFullYear()
        const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
        exportTime = Y + '-' + M
      }
      // 导出计量设备
      fetch({
        url: '/nb/wssd/export',
        params: {
          exportDataType: this.exportDataType,
          exportTime: exportTime
        }
      }).then(data => {
        console.log(data)
        if (data) {
          if (data.id === 0) {
            this.intervalId = setInterval(this.checkExportProcess, 1000)
          } else {
            this.$swal(data.message, '', 'warn')
          }
        } else {
          this.$swal('导出失败!', '', 'error')
        }
      })
      console.log('结束导出计量设备')
    },
    checkExportProcess () {
      fetch({
        url: '/nb/wssd/exportCheck',
        params: {
          exportDataType: this.exportDataType
        }
      }).then(data => {
        console.log(data)
        if (data) {
          console.log(data.message + ',' + data.id)
          if (data.id !== 6) {
            const status = data.id === 0 ? 'success' : 'warn'
            this.$swal(data.message, '', status)
            clearInterval(this.intervalId)
            if (status === 'success') {
              axios({
                method: 'POST',
                url: '/nb/wssd/download?exportDataType=' + this.exportDataType,
                data: {},
                responseType: 'arraybuffer'
              }).then(response => {
                console.log(response)
                if (!response) {
                  return
                }
                let contentDispostion = response.headers['content-disposition'].split(';')[1]
                let fileName = decodeURIComponent(contentDispostion.split('=')[1])
                console.log(contentDispostion)
                let url = window.URL.createObjectURL(new Blob([response.data]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', fileName)
                document.body.appendChild(link)
                link.click()
              }).catch(error => {
                console.log(error)
              })
            }
          }
        } else {
          clearInterval(this.intervalId)
          this.$swal('导出失败!', '', 'error')
        }
      })
    }
  }
}
</script>

<style lang="sass">
  // .data-table-wrapper
  //   width: 100% !important;
  // .data-table
  //   width: 100% !important;
  .export-button
      position: absolute
      padding: 20px
</style>



// WEBPACK FOOTER //
// subdistrictWaterStatistics.vue?e956edd4